import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { AppBar, Toolbar, makeStyles, colors } from '@material-ui/core';
import './Top.css';
const useStyles = makeStyles({
  root: {},
  toolbar: {
    height: 64,
    background: colors.white
  },
});

const TopBar = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <AppBar className={clsx(classes.root, className)} elevation={0} {...rest} color="white">
      <Toolbar className={classes.toolbar}>
        <RouterLink to="/">
          <img src="india.png"alt="trhtrh" />
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
};

export default TopBar;
